module.exports = __webpack_public_path__ + "img/image-error.26a97e2b.svg";